// extracted by mini-css-extract-plugin
module.exports = {"slickdots":"SimpleSlider_slickdots__5nMmV","slick-active":"SimpleSlider_slick-active__Fenkk","customContainer":"SimpleSlider_customContainer__Z_Esq"};